import {Component, Input, OnInit} from '@angular/core';
import {ExcTranslation} from "exc-core";

@Component({
  selector: 'app-message-text',
  templateUrl: './message-text.component.html',
  styles: []
})
export class MessageTextComponent extends ExcTranslation implements OnInit {

  @Input('messageText') messageText;

  constructor() {
    super();
  }

  ngOnInit() {
  }

}
